export enum HiddenModalTypesEnum {
  recommendations = 'recommendations',
  welcome = 'welcome',
  important = 'important',
  contextVideoGuide2 = 'contextVideoGuide2',
  avatarVGTips = 'avatarVGTips',
  avatarVGRecord = 'avatarVGRecord'
}
